/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_Description_LabelInputs */

const vi_shop_category_description_label = /** @type {(inputs: Shop_Category_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả ngắn (tuỳ chọn) — hiện dưới tiêu đề trang danh mục`)
};

/**

* @param {Shop_Category_Description_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_description_label = /** @type {((inputs?: Shop_Category_Description_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Description_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_description_label(inputs)
});